import { affixPrefixCls } from "@/base/components/affix/Affix.component";
import { THEME_PREFIX } from "@/base/constant";
import {
  genComponentStyleHook,
  type FullToken,
  type GenerateStyle,
} from "antd/es/theme/internal";

const genStyle: GenerateStyle<FullToken<"Affix">> = () => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${affixPrefixCls}`]: {},
  },
});

export const useAffixStyle = genComponentStyleHook(
  ["Affix", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
